/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Feature_Ats_Pass_DescInputs */

const en_landing_feature_ats_pass_desc = /** @type {(inputs: Landing_Feature_Ats_Pass_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every resume is scored against real ATS systems before you submit. Keyword optimization, formatting compliance, and section structure — all verified automatically.`)
};

const de_landing_feature_ats_pass_desc = /** @type {(inputs: Landing_Feature_Ats_Pass_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder Lebenslauf wird vor dem Absenden gegen echte ATS-Systeme geprüft. Keyword-Optimierung, Formatierungskonformität und Abschnittsstruktur -- alles automatisch verifiziert.`)
};

const fr_landing_feature_ats_pass_desc = /** @type {(inputs: Landing_Feature_Ats_Pass_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque CV est evalue par rapport aux vrais systemes ATS avant lenvoi. Optimisation des mots-cles, conformite de formatage et structure des sections -- tout verifie automatiquement.`)
};

const es_landing_feature_ats_pass_desc = /** @type {(inputs: Landing_Feature_Ats_Pass_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada CV se evalua contra sistemas ATS reales antes de enviarlo. Optimizacion de palabras clave, cumplimiento de formato y estructura de secciones -- todo verificado automaticamente.`)
};

const it_landing_feature_ats_pass_desc = /** @type {(inputs: Landing_Feature_Ats_Pass_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni CV viene valutato rispetto a sistemi ATS reali prima dellinvio. Ottimizzazione parole chiave, conformita di formattazione e struttura delle sezioni -- tutto verificato automaticamente.`)
};

const nl_landing_feature_ats_pass_desc = /** @type {(inputs: Landing_Feature_Ats_Pass_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elk CV wordt beoordeeld tegen echte ATS-systemen voordat u het verzendt. Zoekwoordoptimalisatie, opmaaknaleving en sectiestructuur -- alles automatisch geverifieerd.`)
};

const pl_landing_feature_ats_pass_desc = /** @type {(inputs: Landing_Feature_Ats_Pass_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kazde CV jest oceniane pod katem prawdziwych systemow ATS przed wyslaniem. Optymalizacja slow kluczowych, zgodnosc formatowania i struktura sekcji -- wszystko zweryfikowane automatycznie.`)
};

const fi_landing_feature_ats_pass_desc = /** @type {(inputs: Landing_Feature_Ats_Pass_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jokainen ansioluettelo pisteytetaan todellisia ATS-jarjestelmia vastaan ennen lahettamista. Avainsanojen optimointi, muotoiluvaatimukset ja osiorakenne -- kaikki tarkistettu automaattisesti.`)
};

const da_landing_feature_ats_pass_desc = /** @type {(inputs: Landing_Feature_Ats_Pass_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvert CV vurderes mod rigtige ATS-systemer foer du sender. Soegneordsoptimering, formateringskrav og sektionsstruktur -- alt verificeret automatisk.`)
};

const sv_landing_feature_ats_pass_desc = /** @type {(inputs: Landing_Feature_Ats_Pass_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varje CV betygsaetts mot riktiga ATS-system innan du skickar. Soekordoptimering, formateringskrav och sektionsstruktur -- allt verifierat automatiskt.`)
};

/**
* | output |
* | --- |
* | "Every resume is scored against real ATS systems before you submit. Keyword optimization, formatting compliance, and section structure — all verified automati..." |
*
* @param {Landing_Feature_Ats_Pass_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_feature_ats_pass_desc = /** @type {((inputs?: Landing_Feature_Ats_Pass_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Feature_Ats_Pass_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_feature_ats_pass_desc(inputs)
	if (locale === "fr") return fr_landing_feature_ats_pass_desc(inputs)
	if (locale === "es") return es_landing_feature_ats_pass_desc(inputs)
	if (locale === "it") return it_landing_feature_ats_pass_desc(inputs)
	if (locale === "nl") return nl_landing_feature_ats_pass_desc(inputs)
	if (locale === "pl") return pl_landing_feature_ats_pass_desc(inputs)
	if (locale === "fi") return fi_landing_feature_ats_pass_desc(inputs)
	if (locale === "da") return da_landing_feature_ats_pass_desc(inputs)
	if (locale === "sv") return sv_landing_feature_ats_pass_desc(inputs)
	return en_landing_feature_ats_pass_desc(inputs)
});